import { inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export class Modal<R extends object = object, D extends object = object> {
  public readonly ɵɵreturnValueType!: R;
  public readonly data = inject(MAT_DIALOG_DATA) as D;
  public readonly dialogRef: MatDialogRef<unknown, R> = inject(MatDialogRef);
}
